import React, { useState } from "react";
import Img from "../../assets/images/quicksupport.webp"
import GenerateURN from "../../utils/generateUrn";
import Swal from "sweetalert2";
import { sendEmailOTP, sendOTP } from "../../api/otpVerification";
import { verifyEmailOTP, verifyOTP } from "../../api/verifyOtp";
import Loader from "../loaderModal";
import { getAuthToken } from "../../services/authSessions";
import { createLead } from "../../api/createLead";
import OtpModal from "../otpModal/otpVerificationModal";

function Claim() {
  const data = [
    {
      id: 1,
      icon: "flaticon-insurance-4",
      step: "STEP 01",
      name: "Call the Police if",
      subname: "Necessary",
    },
    {
      id: 2,
      icon: "flaticon-portfolio",
      step: "STEP 02",
      name: "Everything and",
      subname: "Exchange Information",
    },
    {
      id: 3,
      icon: "flaticon-workgroup",
      step: "STEP 03",
      name: "Contact Insurance",
      subname: "Company",
    },
    {
      id: 4,
      icon: "flaticon-agreement",
      step: "STEP 04",
      name: "Filing Your Insurance",
      subname: "Claim",
    },
  ];

    const [formData, setFormData] = useState({
      name: "",
      email: "",
      phone: "",
      pincode: "",
      remarks: "",
      panNumber: "",
      insurance: "",
    })
  
    const [otpStatus, setOtpStatus] = useState("idle");
    const [otpEmailStatus, setOtpEmailStatus] = useState("idle");
  
    const [otpError, setOtpError] = useState("");
    const [otpModal, setOtpModal] = useState({ show: false, field: "", value: "" });
    const [isVerifyEnabled, setIsVerifyEnabled] = useState(false);
    const [isMobileVerifyEnabled, setIsMobileVerifyEnabled] = useState(false);
    const [isMobileVerified, setIsMobileVerified] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [otpProcessId, setOtpProcessId] = useState(null);
    const [otpLoading, setOtpLoading] = useState(false);
  
  
  
  
    const [verifyLoading, setVerifyLoading] = useState(false);
    const [otpVerified, setOtpVerified] = useState(false);
    // const { otpLoading, otpProcessId  } = useSelector((state) => state.dashboardSlice || {});
  
    const [isEmailValid, setIsEmailValid] = useState(false);
  
    const [errors, setErrors] = useState({});
  
   const handlePhoneChange = (e) => {
      const value = e.target.value;
     
      // Allow only digits
      if (!/^\d*$/.test(value)) return;
  
      // ---------- VALIDATION ----------
      let phoneError = "";
  
      if (value.length === 1 && !/[6-9]/.test(value[0])) {
        phoneError = "First digit must be between 6–9";
      }
  
      if (value.length === 10 && !/^[6-9]\d{9}$/.test(value)) {
        phoneError = "Invalid mobile number";
      }
  
      if (otpStatus == "verified") {
        setIsMobileVerified(false);
        setOtpStatus("idle");
      }
  
      setErrors((prev) => ({
        ...prev,
        phone: phoneError,
      }));
  
      // ---------- UPDATE FORM DATA ----------
      setFormData((prev) => ({
        ...prev,
        phone: value,
      }));
  
      // ---------- RESET OTP STATUS ----------
      // // Any change in phone resets OTP flow
      // const resetOTPState = () => {
      //   setOtp("");
      //   setOtpError("");
      //   setOtpStatus("idle");
      //   setIsMobileVerifyEnabled(false);
      // };
  
      // ---------- ENABLE/DISABLE VERIFY BUTTON ----------
      setIsMobileVerifyEnabled(value.length === 10 && phoneError === "");
    };
  
  
    const handleChange = (e) => {
      const { name, value } = e.target;
  
      if (name == "email") {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const val = emailRegex.test(value)
        setIsEmailValid(emailRegex.test(value));
        console.log("value of email regex", val);
        if (otpEmailStatus == "verified") {
          setIsEmailVerified(false);
          setOtpEmailStatus("idle");
        }
        if (val) { setIsVerifyEnabled(true) };
  
      }
  
  
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };
  
  
    const handleSendOTP = async (field) => {
      setOtpLoading(true);
      const value = formData[field];

      const isMobile = field === "phone";
      const isEmail = field === "email";

      // Validation
      if (isMobile && !/^[0-9]{10}$/.test(value))
        return Swal.fire("Invalid Mobile", "Enter a valid 10-digit mobile number", "error");
      if (isEmail && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value))
        return Swal.fire("Invalid Email", "Enter a valid email address", "error");

      try {
        if (isMobile) {
          await sendOTP(value);
        } else if (isEmail) {
          await sendEmailOTP(value, formData.name);
        }
        setOtpModal({ show: true, field: field, value });
      } catch (err) {
        console.error("Error sending the OTP:", err);
      } finally {
        setOtpLoading(false);  // stop loader no matter what
      }
    }
  
  
    const handleVerifyOtp = async (otp) => {
      setVerifyLoading(true);
      const { field, value } = otpModal;
      if (!/^[0-9]{6}$/.test(otp)) {
        setVerifyLoading(false);
        return Swal.fire("Invalid OTP", "Please enter a valid 6-digit OTP", "warning");
      }

      if (field === "phone") {
        try {
          const res = await verifyOTP(value, otp);
          if (res?.apiResponseCode === "200") {
            // Mark verified first
            setIsMobileVerified(true);
            setOtpStatus("verified");
            setOtpModal({ ...otpModal, show: false });
            setErrors((prev) => ({ ...prev, mobile: "" }));
            Swal.fire("Verified", "Mobile number verified successfully", "success");

            // Update form and close modal
            setFormData((prev) => ({ ...prev, [field]: value }));
            setOtpModal({ show: false, field: "", value: "" });
          } else {

            Swal.fire({
              icon: "error",
              title: "Invalid OTP",
              text: res?.apiResponseMessage || "Please try again.",
            });
            setOtpModal({ ...otpModal, show: false });
          }
        } catch (err) {
          console.error("Error verifying the OTP:", err);
          Swal.fire("Error", `OTP verification failed for ${field}`, "error");
        } finally {
          setVerifyLoading(false);
        }
      }
      else if (field == "email") {

        try {
          const res = await verifyEmailOTP(value, otp);
          if (res?.apiResponseCode === "200") {
            // Mark verified first
            setIsEmailVerified(true);
            setIsEmailValid(true);
            setOtpEmailStatus("verified");
            setIsVerifyEnabled(true);
            setErrors((prev) => ({ ...prev, mobile: "" }));
            Swal.fire("Verified", "Email verified successfully", "success");

            // Update form and close modal
            setFormData((prev) => ({ ...prev, [field]: value }));

            setOtpModal({ show: false, field: "", value: "" });
          } else {
            // If OTP invalid
            Swal.fire({
              icon: "error",
              title: "Invalid OTP",
              text: res?.apiResponseMessage || "Please try again.",
            });
          }
        } catch (err) {
          console.error("Error verifying the OTP:", err);
          Swal.fire("Error", `OTP verification failed for ${field}`, "error");
        } finally {
          setVerifyLoading(false);
          setOtpModal({ show: false, field: "", value: "" });
        }
      }
    }
   const [loading, setLoading] = useState(false);
  
  
    const validateForm = () => {
      const newErrors = {};
  
      // Full Name
      if (!formData.name.trim()) newErrors.name = "Full Name is required";
  
      // Email
      if (!formData.email.trim()) newErrors.email = "Email is required";
      else if (!/^\S+@\S+\.\S+$/.test(formData.email))
        newErrors.email = "Invalid email format";
  
      // Phone
      if (!formData.phone.trim()) newErrors.phone = "Phone Number is required";
      else if (!/^\d{10}$/.test(formData.phone))
        newErrors.phone = "Phone must be 10 digits";
  
      // Insurance Type
      if (!formData.insurance) newErrors.insurance = "Please select insurance type";
  
      // Pin Code
      if (!formData.pincode.trim()) newErrors.pincode = "Pin Code is required";
      else if (!/^\d{6}$/.test(formData.pincode))
        newErrors.pincode = "Pin Code must be a 6-digit number";
  
      //pan code
      if (formData.panNumber) {
        if (!/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(formData.panNumber)) {
          newErrors.panNumber = "Invalid PAN format";
        }
      }
      if (formData.remarks.length < 1) {
        newErrors.remarks = "Remarks is required";
      }
  
      return newErrors;
    };

   const handleSubmit = async (e) => {
      e.preventDefault();
      // setLoading(true);
      if (!isMobileVerified) {
        Swal.fire("Verification Required", "Please verify Phone No. first.", "error");
        return;
      }
  
      const validationErrors = validateForm();
      if (Object.keys(validationErrors).length > 0) {
        setErrors(validationErrors);
        return;
      }
  
      setErrors({});
      setLoading(true);
  
      try {
        setLoading(true);
        const session = await getAuthToken();
        const authToken = session.apiResponseData.responseData.accessToken;
        const urn = GenerateURN();
  
        const payload = {
          name: formData.name || "",
          userEmail: formData.email,
          userMobile: formData.phone,
          userPinCode: formData.pincode,
          // userPan: formData.panNumber,
          remarks: formData.remarks,
          leadSource: "insurance",
          updateHistory: [],
          status: "pending",
          insuranceType: formData.insurance,
        };
  
        const response = await createLead(authToken, urn, payload);
  
        if (response.apiResponseCode == "200" && response.apiResponseData.responseCode == "200") {
          Swal.fire(response.apiResponseData.responseMessage);
          setLoading(false);
        }
        else {
          Swal.fire(response.apiResponseData.responseMessage, "error");
  
        }
        setFormData({
          name: "",
          phone: "",
          email: "",
          insurance: "",
          pincode: "",
          panNumber: "",
          remarks: "",
        });
        setIsEmailVerified(false);
        setIsMobileVerified(false);
      } catch (error) {
        console.error("Error creating lead:", error);
  
      } finally {
        setLoading(false);
      }
    };

  return (
    <>
      <section className="steps-one">
        {(loading || otpLoading) && (
                <div className="loader-wrapper">
                  <Loader />
                </div>
              )}
        <div
          className="steps-one__bg"
          style={{
            backgroundImage: "url(assets/images/shapes/steps-bg-1-1.png)",
          }}
        />

        <div className="container">
          <div className="sec-title text-center">
            <p className="sec-title__tagline">How to Claim</p>

            <h3 className="sec-title__title">
              Here are some important steps to <br />
              take insurance claim.
            </h3>
          </div>

          <ul className="list-unstyled steps-one__list">
            {data.map((item) => (
              <li key={item.id}>
                <div className="steps-one__list__icon">
                  <i className={item.icon} />
                  <div className="steps-one__list__caption">{item.step}</div>
                </div>

                <h3 className="steps-one__list__title">
                  <a href="#">
                    {item.name}
                    <br /> {item.subname}
                  </a>
                </h3>
              </li>
            ))}
          </ul>
        </div>
      </section>
      

      <section className="contact-two contact-two--service">
        <div className="container">
          <div className="row gutter-y-60">
            <div className="col-md-12 col-lg-6">
              <form
                // action="assets/inc/sendemail.php"
                onSubmit = {handleSubmit}
                className="contact-two__form contact-form-validated"
              >
                <div className="sec-title text-start">
                  <p className="sec-title__tagline">Get free estimate</p>

                  <h3 className="sec-title__title">
                    Get an insurance quote to get started!
                  </h3>
                </div>

                <div className="row">
                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-user" />
                        Full Name
                      </div>

                     
                      <input type="text" value={formData.name} placeholder="" name="name" onChange={handleChange} autoComplete='off' />
                      {errors.name && <p className="form-error">{errors.name}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-phone-plus" />
                        Phone No
                      </div>
                      <div className='row'>
                        <div className="col-8">
                          <input type="text" placeholder="" name="phone" value={formData.phone} maxLength={10} onChange={handlePhoneChange} autoComplete='off'/>
                        </div>
                        <div className='col-4'>
                          <button type="button" className='verify-btn' disabled={!isMobileVerifyEnabled || otpModal.show || isMobileVerified} onClick={() => { handleSendOTP("phone") }} > {isMobileVerified ? "Verified" : "Verify"}</button>
                        </div>
                      </div>
                    </div>
                    {errors.phone && <p className="form-error">{errors.phone}</p>}
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-envelope-open" />
                        Email Address
                      </div>
                       <div className='row'>
                        <div className='col-8'>
                          <input type="text" placeholder="" name="email" value={formData.email} onChange={handleChange} autoComplete='off'/>
                        </div>
                        <div className='col-4'>
                          <button type="button" className='verify-btn'
                            disabled={!isVerifyEnabled || otpModal.show || isEmailVerified}
                            onClick={() => { handleSendOTP("email") }} >
                            {isEmailVerified ? "Verified" : "Verify"}
                          </button>
                        </div>
                      </div>
                      {errors.email && <p className="form-error">{errors.email}</p>}
                    </div>
                  </div>

                     <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-envelope-open" />
                        Pan Number
                      </div>
                      <input type="text" placeholder="" name="panNumber" value={formData.panNumber} maxLength={10} autoComplete='off' onChange={(e) => {
                        const value = e.target.value;
                        // Allow only A-Z, a-z, 0-9
                        const cleaned = value.replace(/[^A-Za-z0-9]/g, "").toUpperCase();

                        setFormData(prev => ({ ...prev, panNumber: cleaned }));
                      }} />
                      {errors.panNumber && <p className="form-error">{errors.panNumber}</p>}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-umbrella-beach" />
                        Type Of Insurance
                      </div>

                                           <select name="insurance" value={formData.insurance} className={`niceselect ${formData.insurance ? "selected-insurance" : ""}`} onChange={handleChange}>
                        <option value="">Select Insurance</option>
                        <option value="Car Insurance">Car Insurance</option>
                        <option value="Bike Insurance">Bike Insurance</option>
                        <option value="Health Insurance">Health Insurance</option>
                        <option value="Travel Insurance">Travel Insurance</option>
                        <option value="Home Insurance">Home Insurance</option>
                      </select>
                      {errors.insurance && <p className="form-error">{errors.insurance}</p>}
                    </div>
                  </div>

                <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-user" />
                        Pin Code <span className="form-error" >*</span>
                      </div>

                      <input type="text" placeholder="" autoComplete='off' name="pincode" value={formData.pincode} maxLength={6} onChange={(e) => {
                        const value = e.target.value;

                        // Allow only digits AND limit to 6 digits
                        if (/^\d{0,6}$/.test(value)) {
                          handleChange(e); // update state normally
                        }
                      }} />
                      {errors.pincode && <p className="form-error">{errors.pincode}</p>}

                    </div>
                  </div>

                   <div className="col-md-6">
                    <div className="contact-two__input">
                      <div className="contact-two__input__label">
                        <i className="far fa-umbrella-beach" />
                        Remarks    <span className='form-error'>*</span>
                      </div>

                      <input type="text" placeholder="" autoComplete='off' name="remarks" value={formData.remarks} onChange={handleChange} />
                      {errors.remarks && <p className="form-error">{errors.remarks}</p>}
                    </div>
                  </div>


                  {/* <div className="col-md-12">
                    <div className="contact-two__input">
                      <div className="contact-two__input__title">
                        Limit Of Balance
                      </div>

                      <div className="contact-two__progress-range">
                        <div className="contact-two__balance-box">
                          <p className="contact-two__balance" id="show">
                            $0 <span />
                          </p>
                        </div>
                        <input
                          type="hidden"
                          className="contact-two__balance__input"
                        />
                      </div>
                    </div>
                  </div> */}

                  <div className="col-md-12">
                    <div className="contact-two__input">
                      <button
                        type="submit"
                        className="thm-btn thm-btn--three contact-two__btn"
                      >
                        <span>
                          Get a Quote
                          <i className="far fa-arrow-right" />
                        </span>
                      </button>
                    </div>
                  </div>

                  {errors.submit && <p className="form-error">{errors.submit}</p>}

                </div>
                 {otpModal.show && (
                  <>   {(otpLoading || verifyLoading) && <Loader />}
                    <OtpModal
                      field={otpModal.field}
                      value={otpModal.value}
                      onClose={() => setOtpModal({ show: false, field: "", value: "" })}
                      onVerified={handleVerifyOtp}
                      verifyLoading={verifyLoading}
                    />
                  </>
                )}
              </form>
            </div>

            <div className="col-md-12 col-lg-6">
              <div className="contact-two__images">
                <img src={Img}/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Claim;
